<div @tooltip class="content">
  <div id="actionToolTip-text-message" class="text" [innerHtml]="text"></div>
  <button id="actionToolTip-button-{{ buttonText  | camelCase }}" class="button" *ngIf="buttonText" mat-raised-button (click)="callback()">{{ buttonText }}</button>
</div>
